export const izjava3Lookup =
    [
        {
            id: "1", ime: "истече"
        }
    ]